import React from 'react';
import { motion } from 'framer-motion';
import { useGentleMotion as useReducedMotion } from '../hooks/useGentleMotion';
import { Reveal } from './Reveal';
import { CTAButton } from './CTAButton';
import { Doodles, DoodleSpec } from './Doodles';
import { ConfettiRain } from './ConfettiRain';
import { images } from '../data/bonuses';
const doodles: DoodleSpec[] = [{
  kind: 'star',
  top: '10%',
  left: '5%',
  size: 24,
  color: '#F6C453',
  rotate: -10
}, {
  kind: 'crayon',
  top: '76%',
  left: '92%',
  size: 28,
  color: '#F27C70',
  rotate: 18
}, {
  kind: 'sparkle',
  top: '40%',
  left: '48%',
  size: 18,
  color: '#6CBBD5'
}, {
  kind: 'squiggle',
  top: '86%',
  left: '10%',
  size: 30,
  color: '#2D8C5A'
}];
export function Solution() {
  const reduce = useReducedMotion();
  return <section className="relative w-full overflow-hidden bg-cream py-16 sm:py-24" aria-labelledby="solution-title" data-id="element-276" data-mp="mv9bc1tgb8qp">
      <ConfettiRain count={12} opacity={0.45} data-id="element-277" data-mp="2h7z3ae09e7vg" />
      <Doodles specs={doodles} data-id="element-278" data-mp="2h6o0agen145e" />

      <div className="relative mx-auto grid max-w-content grid-cols-1 items-center gap-12 px-5 sm:px-8 lg:grid-cols-2" data-id="element-279" data-mp="70ie22f6pv6j">
        <motion.div className="order-2 flex justify-center lg:order-1" animate={reduce ? undefined : {
        y: [0, -9, 0],
        rotate: [1, -1.5, 1]
      }} transition={{
        duration: 10,
        repeat: Infinity,
        ease: 'easeInOut'
      }} data-id="element-280" data-mp="2zyg4wmsenjc">
          {/* Coloured plate so the cover reads as a clean cut-out, never a white box */}
          <div className="flex w-full max-w-[460px] items-end justify-center rounded-[2.5rem] px-8 pt-10" style={{
          backgroundColor: "#FCE3B858"
        }} data-id="element-281" data-mp="3k7k4deercu1a">
            <img src={images.mainBook} alt="Mockup del ebook El Gran Reto Creativo, 365 ideas" className="cutout h-auto w-full max-w-[380px]" width={1024} height={1024} loading="lazy" decoding="async" style={{
            backgroundColor: "#CAC8A47D"
          }} data-id="element-282" data-mp="3u5znau3mswzp" />
          </div>
        </motion.div>

        <div className="order-1 lg:order-2" data-id="element-283" data-mp="14gedt8g4ew44">
          <Reveal data-id="element-284" data-mp="14fmi7xmiwydu">
            <h2 id="solution-title" className="font-display text-2xl font-extrabold uppercase leading-tight text-navy sm:text-4xl" data-id="element-285" data-mp="14i8pdw5i5bvj">
              Por eso creamos
              <br data-id="element-286" data-mp="1gkidm7kgu2cx" />
              <span className="text-brandgreen" data-id="element-287" data-mp="1lhiiwg9hr12z">El Gran Reto Creativo</span>
            </h2>
            <p className="mt-4 max-w-md font-sans text-base leading-relaxed text-muted" data-id="element-288" data-mp="1qglezb7htwyt">
              Un ebook digital con 365 ideas explicadas paso a paso. No hay que leerlo
              completo.
            </p>

            <div className="mt-6 flex flex-wrap gap-3" data-id="element-289" data-mp="xro61yp69ciq">
              {['Abre.', 'Elige.', 'Crea.'].map(s => <span key={s} className="rounded-xl bg-white px-4 py-2 font-display text-sm font-extrabold uppercase tracking-wide text-navy shadow-soft" data-id="element-290" data-mp="12qr1crfco4di">
                  {s}
                </span>)}
            </div>

            <div className="mt-8" data-id="element-291" data-mp="f0wqgfelcpvw">
              <CTAButton data-id="element-292" data-mp="ezvfsc1hm5ep">Quiero empezar a crear</CTAButton>
            </div>
          </Reveal>
        </div>
      </div>
    </section>;
}